import type { PlayerAIToolProposalPayload } from "./playerai.types";
import { proposalChanges } from "./proposal-presentation";
import { ProposalDiffBlock } from "./ProposalDiffBlock.js";
import { ProposalValue } from "./ProposalValue";

export function ProposalChangePreview({
  payload,
}: {
  payload: PlayerAIToolProposalPayload;
}) {
  const changes = proposalChanges(payload);
  if (!changes.length)
    return (
      <p className="mt-2 text-xs text-pb-text-muted">
        Detailed changes are unavailable in this saved proposal. Request a new
        proposal if you need more detail.
      </p>
    );
  return (
    <div className="mt-2 min-w-0 space-y-2 text-xs">
      <p className="font-medium text-pb-text">
        {payload.preview?.kind === "collection_add"
          ? "Add "
          : payload.preview?.kind === "collection_remove"
            ? "Remove "
            : ""}
        {changes.length}{" "}
        {payload.preview?.kind === "collection_add" ||
        payload.preview?.kind === "collection_remove"
          ? changes.length === 1
            ? "item"
            : "items"
          : changes.length === 1
            ? "detail"
            : "details"}
      </p>
      {changes.map((change, index) => (
        <details
          key={index}
          open={changes.length === 1}
          className="min-w-0 rounded border border-pb-border bg-pb-shell/50"
        >
          <summary className="cursor-pointer px-3 py-2 font-medium text-pb-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-pb-teal">
            {change.label}
          </summary>
          <div className="min-w-0 space-y-2 border-t border-pb-border p-3 [overflow-wrap:anywhere]">
            {change.comparison && (
              <ProposalDiffBlock side="removed" label="Before">
                <ProposalValue value={change.before} />
              </ProposalDiffBlock>
            )}
            <ProposalDiffBlock
              side="added"
              label={change.comparison ? "After" : "Proposed change"}
            >
              <ProposalValue value={change.after} />
            </ProposalDiffBlock>
          </div>
        </details>
      ))}
    </div>
  );
}
